import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  background: #00000078;
  z-index: 99999999;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CalendarWrap = styled.div`
  background: #ffff;
  padding: 20px 30px;
`;

export const ContainerWrap = styled.div``;

export const ContainerCalendar = styled.div`
  .react-datepicker {
    border: none;
  }
  .react-datepicker__header {
    background-color: transparent;
    border-bottom: none;
    .react-datepicker__current-month,
    .react-datepicker-time__header,
    .react-datepicker-year-header {
      color: #00f;
      font-family: "Mangueira", sans-serif;
      font-size: 14px;
      font-weight: 700;
      text-transform: capitalize;
    }
  }

  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    border-color: #00f;
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: "";
    display: block;
    height: 9px;
    position: absolute;
    width: 9px;
    top: 8px;
  }

  .react-datepicker__navigation:hover *::before {
    border-color: #00f;
    filter: opacity(0.5);
  }

  .react-datepicker__day-names {
    margin-bottom: -8px;
    margin-top: 18px;
  }

  .react-datepicker__day-name {
    color: #00f;
    font-family: "Mangueira Bold", sans-serif;
    font-size: 13px;
    font-weight: 700;
    width: 40px;
    height: 40px;
  }

  .react-datepicker__day {
    color: #00f;
    font-family: "Mangueira", sans-serif;
    font-size: 13px;
    font-weight: 300;
    height: 40px;
    width: 40px;
    border-radius: 50% !important;
    text-align: center;
    padding-top: 6px;
  }

  .react-datepicker__day--selected {
    background-color: #97f8fb;
    font-weight: 700;
  }

  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    background-color: #97f8fb;
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background-color: unset;
  }

  .react-datepicker__day--disabled {
    color: #ccc;
    &:hover {
      background-color: unset;
    }
  }
`;

export const Header = styled.div`
  background-color: #00f;
  padding: 18px 25px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const YearText = styled.span`
  font-family: "Mangueira", sans-serif;
  color: #97f8fb;
  font-size: 36px;
  font-weight: 400;
`;

export const DateText = styled.span`
  font-family: "Mangueira Bold", sans-serif;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  width: 100%;
  text-align: center;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 32px;
`;

export const Button = styled.button`
  color: #00f;
  font-family: "Mangueira Bold", sans-serif;
  font-size: 13px;
  font-weight: 500;

  background-color: unset;
  border: none;
`;
